import * as types from '../mutation-types'
import iaPromoApi from '../../api/iaPromoApi'

const state = {
    advisorsPromoData: {},
    finishPromoLoading: false,
    partitionIsCreated: undefined
}

const getters = {
    advisorsPromoData: state => {
        return state.advisorsPromoData;
    }
}

const mutations = {
    [types.SET_ADVISORS_PROMODATA](state, data) {
        state.advisorsPromoData = data;
    },
    [types.FINISH_IA_PROMO_LOADING](state, data) {
        state.finishPromoLoading = data;
    },
    [types.SET_CREATED_PARTITION](state, data) {
        state.partitionIsCreated = data;
    }
}

const actions = {
    getAdvisorsPromoData({ commit, state }, {iaPartner}) {
        commit(types.FINISH_IA_PROMO_LOADING, false);
        return new Promise((resolve, reject) => {
            iaPromoApi.getAdvisorsPromoData(iaPartner)
                .then(res => {
                    commit(types.FINISH_IA_PROMO_LOADING, true);
                    commit(types.SET_ADVISORS_PROMODATA, res);
                    resolve(res);
                })
                .catch(e => {
                    commit(types.FINISH_IA_PROMO_LOADING, true);
                    reject(e);
                });
        });
    },

    createdPartition({ commit, state }, flag) {
        commit(types.SET_CREATED_PARTITION, flag);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}